<template>
    <div class="sidebar">
        <div class="lefty-ad-zone"></div>

        <WatsonThemeItsThatEasy v-if="!hideItsThatEasy" />

        <BecomeAPartner v-if="!hideBecomeAPartner" />

        <TopPages
            v-if="topPages.length > 0"
            :pages="topPages"
        />

        <div class="sidebar__sticky">
            <WatsonThemeGuide
                v-if="links.length > 0"
                :links="links"
                :cta-shown="showCta && !!postTypes.ctaBlock"
            />

            <WatsonThemeCtaBlock
                v-if="showCta && !!postTypes.ctaBlock"
                v-bind="postTypes.ctaBlock"
                :sidebar="true"
            />

            <watson-theme-email-banner
                v-if="showEmailBannerSidebar && !!postTypes.emailBanner"
                v-bind="postTypes?.emailBanner"
                :sidebar="true"
            />
        </div>
    </div>
</template>

<script setup>

import WatsonThemeItsThatEasy from '../../../components/its-that-easy/watson-theme-its-that-easy.vue';
import BecomeAPartner from '../../../components/become-a-partner/become-a-partner.vue';
import TopPages from '../../../components/top-pages/watson-theme-top-pages.vue';
import WatsonThemeGuide from '../../../components/guide/watson-theme-guide.vue';
import WatsonThemeCtaBlock from '../../../../../greenmatch/components/cta-block/watson-theme-cta-block.vue';
import WatsonThemeEmailBanner from '../../../../components/email-banner/watson-theme-email-banner.vue';

defineProps({
    hideItsThatEasy: {
        type: Boolean,
        required: false,
        default: false,
    },
    hideBecomeAPartner: {
        type: Boolean,
        required: false,
        default: false,
    },
    showCta: {
        type: Boolean,
        required: false,
        default: false,
    },
    showEmailBannerSidebar: {
        type: Boolean,
        required: false,
        default: false,
    },
    topPages: {
        type: Array,
        required: false,
        default: () => [],
    },
    links: {
        type: Array,
        required: false,
        default: () => [],
    },
    postTypes: {
        type: Object,
        required: false,
        default: () => {},
    },
});

</script>

<style lang="scss" scoped>
@use 'watson-theme-content-sidebar';
</style>
